import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, StatCard } from "@/components/Common";
import { toast } from "sonner";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/stats");
        setStats(data);
      } catch (e) {
        toast.error("İstatistikler yüklenemedi");
      } finally { setLoading(false); }
    })();
  }, []);

  const s = stats || {};
  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <PageHeader
        title="Yönetici Paneli"
        subtitle="Penz'e kayıt olan firmaların özet görünümü"
      />

      {loading ? (
        <div className="text-sm text-slate-500">Yükleniyor...</div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <StatCard label="Toplam Firma" value={s.total_companies ?? 0} accent="slate" testId="admin-stat-total" />
            <StatCard label="Deneme Süresindeki Firma" value={s.trial_companies ?? 0} accent="emerald" testId="admin-stat-trial" />
            <StatCard label="Deneme Süresi Dolmuş Firma" value={s.trial_expired_companies ?? 0} accent="amber" testId="admin-stat-trial-expired" />
            <StatCard label="Aktif Firma" value={s.active_companies ?? 0} accent="emerald" testId="admin-stat-active" />
            <StatCard label="Pasif Firma" value={s.passive_companies ?? 0} accent="red" testId="admin-stat-passive" />
            <StatCard label="Son 30 Günde Yeni Kayıt" value={s.registrations_last_30_days ?? 0} accent="slate" testId="admin-stat-last-30" />
            <StatCard label="Bugün Yeni Kayıt" value={s.registrations_today ?? 0} accent="slate" testId="admin-stat-today" />
          </div>
        </>
      )}
    </div>
  );
}
